export default {
  magazine: {
    magazine: 'Magazin',
    article: 'Artikel',
    category: 'Themengebiet',

    footerLinks: {
      title: 'Unsere Themen',
    },

    articlePage: {
      datePrefix: 'Aktualisiert am',
      supplierProfileSubtitle: 'Partner und Autor',
      relatedArticles: {
        sectionTitle: 'Artikel zu ähnlichen Themen',
      },
      supplierEvents: {
        sectionTitle: 'Entdecke Kurse von {partnerName}',
      },
    },
  },
}
